<template>
    <div>
        <h5>Saisonnalité et Provenance</h5>
        <el-button @click="openAdd" plain>Ajouter</el-button>
        <table class="table table-hover table-outline table-vcenter text-nowrap card-table">
            <thead>
                <tr>
                    <th class="text-center">Région</th>
                    <th class="text-center">Localité</th>
                    <th class="text-center"></th>
                    <th class="text-center"><i class="icon-settings"></i></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(season, index) in seasons" :key="index">
                    <td>
                        {{ season.region ? season.region.name :  '-' }}
                    </td>
                    <td>
                        {{ season.localite ? season.localite.name :  '-' }}
                    </td>
                    <td>
                        <span :class="{out: season.january == 'hors_saison'}" class="block-season" >JAN</span>
                        <span :class="{out: season.february == 'hors_saison'}" class="block-season" >FÉV</span>
                        <span :class="{out: season.march == 'hors_saison'}" class="block-season" >MAR</span>
                        <span :class="{out: season.april == 'hors_saison'}" class="block-season" >AVR</span>
                        <span :class="{out: season.may == 'hors_saison'}" class="block-season" >MAI</span>
                        <span :class="{out: season.june == 'hors_saison'}" class="block-season" >JUN</span>
                        <span :class="{out: season.july == 'hors_saison'}" class="block-season" >JUL</span>
                        <span :class="{out: season.august == 'hors_saison'}" class="block-season" >AOÛ</span>
                        <span :class="{out: season.september == 'hors_saison'}" class="block-season" >SEP</span>
                        <span :class="{out: season.october == 'hors_saison'}" class="block-season" >OCT</span>
                        <span :class="{out: season.november == 'hors_saison'}" class="block-season" >NOV</span>
                        <span :class="{out: season.december == 'hors_saison'}" class="block-season" >DÉC</span>
                    </td>
                    <td>
                        <el-button @click="openEdit(season)" size="mini" type="primary" icon="el-icon-edit" circle></el-button>
                        <el-button @click="destroy(season)" size="mini" type="danger" icon="el-icon-delete" circle></el-button>
                    </td>
                </tr>
            </tbody>
        </table>
        <el-dialog title="Edition" :visible.sync="dialogEdit" width="80%" :before-close="handleClose">

            <div class="row">
                <div v-for="(month, index) in months" :key="index" class="col-md-4">
                    <div class="form-group">
                        <label class="form-label">{{ month.label }}</label>
                        <select v-model="season[month.value]"  class="form-control custom-select">
                            <option value="">Choisir une saisonnalité</option>
                                <option value="de_saison">De saison</option>
                                <option value="hors_saison">Hors saison</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="form-label">Saisonnalité</label>
                        <el-input placeholder="Texte" type="textarea" :rows="5" v-model="season.text"></el-input>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="form-label">Localité</label>
                        <select v-model="season.localite_id"  class="form-control custom-select">
                            <option value="">Choisir une localité</option>
                            <option v-for="(localite, index) in localites" :key="index" :value="localite.id">{{ localite.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="form-label">Label</label>
                        <el-input placeholder="Même label que l'ingrédient" v-model="season.label"></el-input>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogEdit = false">Annuler</el-button>
                <el-button type="primary" @click="update()">Enregistrer</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Ajout" :visible.sync="dialogAdd" width="40%">
            <div class="form-group">
                <label class="form-label">Région</label>
                <el-select v-model="region_id" placeholder="Choisisez une région" >
                    <el-option v-for="(region, index) in regionsAvailable" :key="index" :value="region.id"  :label="region.name"></el-option>
                </el-select>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAdd = false">Annuler</el-button>
                <el-button type="primary" @click="add()">Enregistrer</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            seasons: [],
            regions: [],
            localites: [],
            dialogEdit: false,
            dialogAdd: false,
            months: [
                { value:'january', label: 'Janvier'},
                { value:'february', label: 'Février'},
                { value:'march', label: 'Mars'},
                { value:'april', label: 'Avril'},
                { value:'may', label: 'Mai'},
                { value:'june', label: 'Juin'},
                { value:'july', label: 'Juillet'},
                { value:'august', label: 'Août'},
                { value:'september', label: 'Septembre'},
                { value:'october', label: 'Octobre'},
                { value:'november', label: 'Novembre'},
                { value:'december', label: 'Décembre'},
            ],
            season: {},
            region_id: null
        }
    },
    computed: {
        regionsAvailable() {
            var used = this.seasons.map(v => v.region_id)
            return this.regions.filter(v => used.indexOf(v.id) == -1)
        }
    },

    props: {
        ingredientId: {
            required: true
        }
    },

    created() {
        axios.get('/pro/ingredients/'+this.ingredientId+'/seasons').then((r)=>{
            this.seasons = r.data.data
            this.localites = r.data.localites
            this.regions = r.data.regions
        })
    },
    methods: {
        handleClose(done)
        {
            this.season = {}
            done()
        },
        openEdit(season)
        {
            this.season = {...season}
            this.dialogEdit = true
        },
        update()
        {
            axios.post('/pro/ingredients/'+this.ingredientId+'/seasons/'+this.season.id, this.season).then((r)=>{
                this.seasons = this.seasons.map(v => v.id == r.data.data.id ? {...v,...r.data.data} : v)
                this.dialogEdit = false
            })
        },
        openAdd()
        {
            this.region = null
            this.dialogAdd = true
        },
        add()
        {
            if( !this.region_id ) {
                return
            }
            axios.post('/pro/ingredients/'+this.ingredientId+'/seasons', {region_id: this.region_id}).then((r)=>{
                this.seasons.push(r.data.data)
                this.dialogAdd = false
                this.openEdit(r.data.data)
            })
        },
        destroy(season)
        {
            this.$confirm('Ceci effacera la saison. Continuer?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Annuler',
                type: 'warning'
                }).then(() => {
                    axios.delete('/pro/ingredients/'+this.ingredientId+'/seasons/'+season.id).then((r)=>{
                        this.seasons = this.seasons.filter(v => v.id != season.id)
                    })
                }).catch(() => {

                });
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
